import {
  FilterMode,
  CollectiveManagementSocietyCreateMutationVariables,
  CollectiveManagementSociety_OrderBy,
  CollectiveManagementSociety,
  SortOrder,
  CollectiveManagementSociety_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const collectiveManagementSocietyService = {
  createOne: buildCreateOne(
    (
        collectiveManagementSocietyCreateVariables: CollectiveManagementSocietyCreateMutationVariables
      ) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.collectiveManagementSocietyCreate(
          collectiveManagementSocietyCreateVariables
        );
        return result.collectiveManagementSocietyCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.collectiveManagementSocietyOne({ id });
    return result.collectiveManagementSocietyOne as CollectiveManagementSociety;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: CollectiveManagementSociety_OrderBy[] | null = null,
    filter: CollectiveManagementSociety_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: CollectiveManagementSociety_Filter | undefined;
    if (searchValue !== "") {
      where = {
        OR: [
          { name: { contains: searchValue, mode: FilterMode.Insensitive } },
          { acronym: { contains: searchValue, mode: FilterMode.Insensitive } },
        ],
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.collectiveManagementSocietyListWithOffset({
      offset,
      take,
      orderBy: orderBy
        ? orderBy
        : [{ name: SortOrder.Asc }, { acronym: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.collectiveManagementSocietyListWithOffset
    ) as CollectiveManagementSociety[];
    return { list, orderBy };
  },
};
